import { configureStore } from '@reduxjs/toolkit'
import authTokenSlice from './reducer/authToken'
import farmerModuleSlice from 'app/farmer360/store/app'
import userRoleSlice from './reducer/requestflow'
import vendorSlice from './reducer/vendor'

const store = configureStore({
  reducer: {
    authToken: authTokenSlice,
    farmerModule: farmerModuleSlice,
    userRole: userRoleSlice,
    vendor: vendorSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
